import React, { useState, useEffect } from "react";
import { useI18n } from "@/i18n";

export default function CookieConsent() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("cookie-consent")) setShow(true);
  }, []);
  const decide = (v) => {
    localStorage.setItem("cookie-consent", v);
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-graphite border-t border-ink/10 px-6 py-4" data-testid="cookie-consent">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center gap-4 justify-between">
        <p className="text-sm text-ink-soft">{t("cookie.text")}</p>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => decide("necessary")} data-testid="cookie-decline"
            className="text-sm text-ink-muted hover:text-ink transition-colors px-4 py-2">
            {t("cookie.decline")}
          </button>
          <button onClick={() => decide("all")} data-testid="cookie-accept"
            className="text-sm bg-gold text-void px-5 py-2 hover:bg-gold-hover transition-colors">
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
